module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Edit-text-ed91361cd89a1318c35202a39cd4e637.svg";